export default "__VITE_ASSET__56b0c291__"